import { FIELD_TYPES } from '@iconik-io/shared-lib/src/constants/search';
import type { UploaderState } from '@iconik-io/uploader/src/state';

import type { Column } from '../../ui/table/types';
import FileIcons from './file_icons';
import { FileStatus } from './file_status';
import FileTitle from './file_title';

const columns: Column<UploaderState>[] = [
  {
    name: 'fileInfo.targetPath',
    type: FIELD_TYPES.CUSTOM_COMPONENT,
    style: { width: 'auto', overflow: 'hidden' },
    component: ({ item }) => <FileTitle item={item} />,
  },
  {
    name: 'id',
    type: FIELD_TYPES.CUSTOM_COMPONENT,
    style: { width: 'auto' },
    component: ({ item }) => <FileIcons item={item} />,
  },
  {
    name: 'status',
    type: FIELD_TYPES.CUSTOM_COMPONENT,
    style: { width: 'auto' },
    component: ({ item }) => <FileStatus item={item} />,
  },
  {
    name: 'options',
    type: FIELD_TYPES.MENU,
    style: { width: 'auto' },
  },
];

export default columns;
